import { cn } from "../lib/utils";

export default function PageHeader({ title, description, actions, children, className }) {
  const right = actions || children;
  return (
    <div className={cn("border-b border-slate-200 bg-white px-6 py-6", className)}>
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
        <div>
          <h1 className="font-display text-3xl font-bold tracking-tight text-slate-900" data-testid="page-title">
            {title}
          </h1>
          {description && (
            <p className="mt-2 text-sm text-slate-600 max-w-2xl">{description}</p>
          )}
        </div>
        {right && <div className="flex items-center gap-2">{right}</div>}
      </div>
    </div>
  );
}
